<template>
  <div>
    <card-roles-table />
  </div>
</template>
<script>
/* 
  Class: Roles
  Description: This class representing a main entry point for roles.
*/

/* Imports */
import CardRolesTable from '@/components/Cards/Roles/CardRolesTable.vue';
/* /Imports/ */

export default {
  /* 
    Define different meta options. 
  */
  metaInfo() {
    return {
      title: this.$appName,
      titleTemplate: '%s | ' + this.$route.name
    };
  },

  /* 
    Define different components for reusability. 
  */
  components: {
      CardRolesTable
  }
}
</script>